// The client's side of the Watchlist add-security contracts: the discovery
// search response and the Stage answers that mean a choice is out of date.
// The Add Security dialog, its ticker builder and the grid's "+ Add security"
// row all read the server through these, so a contract change is made once.

export const DISCOVERY_CONTRACT_VERSION = 'watchlist-security-discovery.v2';
export const SEARCH_RESULT_LIMIT = 20;
const DISCOVERY_MATCH_KINDS = ['exact_ticker', 'ticker_prefix', 'company_prefix', 'company_fuzzy'];

/** True when a discovery search response has the shape this client reads. */
export function isValidDiscoveryResponse(response) {
    if (
        !response
        || response.contract_version !== DISCOVERY_CONTRACT_VERSION
        || !Array.isArray(response.results)
        || response.results.length > SEARCH_RESULT_LIMIT
    ) return false;
    const capacity = response.capacity;
    if (
        !capacity
        || !Number.isSafeInteger(capacity.max_securities)
        || !Number.isSafeInteger(capacity.current_security_count)
        || capacity.max_securities < 0
        || capacity.current_security_count < 0
    ) return false;
    return response.results.every((result) => (
        result
        && typeof result.basket_key === 'string'
        && Boolean(result.basket_key)
        && typeof result.preview_token === 'string'
        && Boolean(result.preview_token)
        && typeof result.option_token === 'string'
        && Boolean(result.option_token)
        && typeof result.ticker === 'string'
        && Boolean(result.ticker)
        && typeof result.country === 'string'
        && Boolean(result.country)
        && DISCOVERY_MATCH_KINDS.includes(result.match_kind)
        && result.evidence_state === 'identity_known'
        && typeof result.already_active === 'boolean'
    ));
}

/**
 * Search results in the order both search boxes show them: US listings
 * first, then every other listing, each group alphabetical by ticker.
 * Works on any `{ ticker, country }` objects and returns a new array.
 */
export function orderSearchResults(results) {
    const group = (result) => (String(result.country || '').toUpperCase() === 'USA' ? 0 : 1);
    return [...results].sort((left, right) => (
        group(left) - group(right)
        || String(left.ticker || '').localeCompare(String(right.ticker || ''))
    ));
}

// Stage error codes that mean a chosen listing is out of date.
const STALE_STAGE_CODES = new Set([
    'security_resolution_add_options_stale',
    'security_resolution_add_option_stale',
    'selection_token_stale',
]);

export function isStaleStageCode(code) {
    return STALE_STAGE_CODES.has(code);
}

/** The Stage item indices a stale failure names (`detail.errors[].index`). */
export function staleStageItemIndices(detail, itemCount) {
    if (!Array.isArray(detail?.errors)) return [];
    return [...new Set(detail.errors
        .map((item) => item?.index)
        .filter((index) => (
            Number.isSafeInteger(index)
            && index >= 0
            && index < itemCount
        )))];
}
